import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: ${(props: { isLoading: boolean }) => props.isLoading && 'center'};
  height: 100vh;
`;
